module.exports = __webpack_public_path__ + "static/media/small-logo-policy.4d0fcf75.svg";